export default {
	ThemeColor: '#6B3DFF',
	SidebarSize: '250px',
};
